let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Tj3m")).then(() => parcelRequire('eH99p'));